import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useProvince } from "@/contexts/ProvinceContext";

export default function ColumnistsSlider() {
  const { selected } = useProvince();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/columnists${selected ? `?province_id=${selected.id}` : ""}`).then((r) => setItems(r.data || [])).catch(() => {});
  }, [selected?.id]);
  if (!items.length) return null;
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-1 h-6 bg-[#e11d2a] rounded-full"></div>
          <h3 className="text-lg font-black">KÖŞE YAZARLARI</h3>
        </div>
        <Link to="/kose-yazilari" className="text-xs font-semibold text-[#e11d2a] hover:underline">Tümünü Gör →</Link>
      </div>
      <div className="h-slider flex gap-3 overflow-x-auto pb-2 no-scrollbar">
        {items.map((c) => (
          <div key={c.id} className="shrink-0 w-64 bg-white border border-gray-100 rounded-lg p-4">
            <div className="flex items-center gap-3">
              <img src={c.photo || "https://i.pravatar.cc/200"} alt={c.name} className="w-14 h-14 rounded-full object-cover" />
              <div>
                <Link to={`/kose-yazilari/${c.slug}`} className="font-bold text-sm hover:text-[#e11d2a]">{c.name}</Link>
                <div className="text-[11px] text-gray-500">Köşe Yazarı</div>
              </div>
            </div>
            {c.latest_column && (
              <Link to={`/yazi/${c.latest_column.slug}`} className="block mt-3 text-sm font-medium line-clamp-2 hover:text-[#e11d2a]">
                {c.latest_column.title}
              </Link>
            )}
            <div className="mt-2">
              <Link to={`/kose-yazilari/${c.slug}`} className="text-xs font-semibold text-gray-500 hover:text-[#e11d2a]">Tüm yazılar →</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
